import { AuditEntriesService } from '@/backend/market'
import { ActivityLogRepository } from '../../domain/repositories/ActivityLogRepository'
import { ActivityLogModel } from '../models/ActivityLogModel'
import { ActivityLogFilterModel } from '../models/ActivityLogFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { ActivityLogEntity } from '../../domain/entities/ActivityLogEntity'
import type { ActivityLogFilterEntity } from '../../domain/entities/ActivityLogFilterEntity'

export class ActivityLogRepositoryImpl implements ActivityLogRepository {
  async getActivityLog(
    filterData: ActivityLogFilterEntity
  ): Promise<PaginateEntity<ActivityLogEntity[]> | { error: true }> {
    const filterModel = new ActivityLogFilterModel(filterData)
    try {
      const response = await AuditEntriesService.getActivityLogsAdmin(filterModel)
      const userModels = response.items?.map((item) => new ActivityLogModel(item))
      const activityLogResponse = new PaginateEntity<ActivityLogModel[]>(response, userModels)

      return activityLogResponse
    } catch {
      return { error: true }
    }
  }
}
